import { Box, BoxProps, Button, ButtonProps, Stack, Typography, TypographyProps } from '@mui/material';
import { Link } from 'components/common/Link';
import SafeImage from 'components/SafeImage';
import { MenuItem } from 'generated/graphql';
import useMenuSlugParser from 'hooks/useMenuSlugParser';
import useMarket from 'stores/useMarket';
import { colors } from 'styles/theme/colors';

type SubCategoryType = {
    menuItem: MenuItem;
    boxProps?: BoxProps;
    width?: number;
    height?: number;
    typographyProps?: TypographyProps;
    buttonProps?: ButtonProps;
};

export default function SubCategory(props : SubCategoryType) {
    const { menuItem, boxProps, typographyProps, buttonProps, height = 160 } = props;

    const market = useMarket((state) => state.market);

    const { parseSlug } = useMenuSlugParser();

    return (
        <Box {...boxProps}>
            <Button
                disableRipple
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    color: 'black',
                    padding: 0,
                    cursor: 'pointer',
                    '& img': {
                        aspectRatio: '6 / 5',
                        objectFit: 'contain',
                        width: '120px',
                        maxWidth: '100%',
                        marginInline: 'auto',
                        transition: 'transform 0.3s',
                    },
                    '&:hover': {
                        backgroundColor: 'transparent',
                        color: colors.pink2,
                    },
                    '&:hover img': {
                        transform: 'scale(1.05)',
                    },
                }}
                LinkComponent={Link}
                href={parseSlug(menuItem)}
                tabIndex={0}
                {...buttonProps}
            >
                {menuItem.image ? (
                    <SafeImage
                        src={menuItem.image}
                        alt=""
                        height={height}
                        quality={90}
                        priority
                    />
                ) : (
                    <Box sx={{ aspectRatio: '6 / 5', width: '100%' }} />
                )}
                <Typography
                    {...typographyProps}
                    sx={{ textTransform: 'capitalize', textAlign: 'center', marginTop: '4px', ...typographyProps?.sx }}
                >
                    {menuItem.title.toLowerCase()}
                </Typography>
            </Button>
        </Box>
    );
}
